










import 'reflect-metadata'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class CheckBoxOnColumn extends Vue { 
	@Prop(Object) public tableItem: any
	@Prop(String) readonly cloumnName: any
	@Prop(Boolean) readonly disabled: any
	@Prop() readonly checked: any
	
	menu = false

	get setChecker () {
		if (this.checked !== undefined) {
			if (this.checked === false) return false
			if (this.checked === true) return true
		}

		return this.tableItem[`${this.cloumnName}`]
	}

	set setChecker (newValue: any) {
		this.tableItem[`${this.cloumnName}`] = newValue
	}

}
